import { render, staticRenderFns } from "./Addons.vue?vue&type=template&id=3976cc92&scoped=true&"
import script from "./Addons.vue?vue&type=script&lang=js&"
export * from "./Addons.vue?vue&type=script&lang=js&"
import style0 from "./Addons.vue?vue&type=style&index=0&id=3976cc92&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3976cc92",
  null
  
)

export default component.exports